// Shared columns for Project Page Details & Create

export const PP_PICKLIST_LABELS = {
  TYPE: "Project_Page_Type__c",
};

export function buildInfoFieldsForProjectPage({
  isEditing = false,
  form = null,
  data = null,
} = {}) {
  const showQualStep = (form || data)?.info.type === "Project Qualifying Page";

  return [
    { label: "Name", path: "info.name", type: "text", readOnly: true },
    {
      label: "Type",
      path: "info.type",
      type: "select",
      picklistLabel: PP_PICKLIST_LABELS.TYPE,
    },
    {
      label: "Project Page Description",
      path: "info.projectPageDescription",
      type: "textarea",
    },
    { label: "Active", path: "info.active", type: "checkbox" },
    {
      label: "Duplicate Check",
      path: "info.duplicateCheck",
      type: "text",
      readOnly: true,
    },
    ...(showQualStep
      ? [
          {
            label: "Project Qualification Step",
            path: "info.qualificationStep",
            type: "lookup",
            lookupObject: "ProjectQualificationStep",
            value: (form || data)?.info?.qualificationStep || "—",
            valueLabel: (form || data)?.info?.qualificationStepName || "—",
            projectId: (form || data)?.info?.projectId || "",
            projectObjectiveId: (form || data)?.info?.projectObjectiveId,
          },
        ]
      : []),
    {
      label: "Project Objective",
      path: "info.projectObjectiveId",
      type: "lookup",
      lookupObject: "ProjectObjective",
      value: !isEditing
        ? (form || data)?.info?.projectObjectiveName || "—"
        : (form || data)?.info?.projectObjectiveId || "—",
      linkTo:
        !isEditing && (form || data)?.info?.projectObjectiveId
          ? `/po/${(form || data)?.info?.projectObjectiveId}`
          : undefined,
      valueLabel: (form || data)?.info?.projectObjectiveName || "—",
    },
    // Project lookup field
    {
      label: "Project",
      path: "info.projectId",
      type: "lookup",
      lookupObject: "Project",
      value: !isEditing
        ? (form || data)?.info?.projectName
        : (form || data)?.info?.projectId || "—",
      linkTo:
        !isEditing && (form || data)?.info?.projectId
          ? `/p/${(form || data)?.info?.projectId}`
          : undefined,
      valueLabel: (form || data)?.info?.projectName || "—",
    },
  ];
}

export function buildSysFieldsForProjectPage() {
  return [
    {
      label: "CreatedById",
      path: "sys.createdById",
      type: "text",
      readOnly: true,
    },
    {
      label: "LastModifiedById",
      path: "sys.lastModifiedById",
      type: "text",
      readOnly: true,
    },
  ];
}

// Create modal fields
export function buildCreateFieldsForProjectPage(form) {
  const showQualStep = form?.projectPageType === "Project Qualifying Page";
  return [
    {
      cols: 2,
      fields: [
        {
          label: "Project Page Type",
          path: "projectPageType",
          type: "select",
          required: true,
          picklistLabel: PP_PICKLIST_LABELS.TYPE,
        },
        { label: "Active", path: "active", type: "checkbox" },
      ],
    },
    ...(showQualStep
      ? [
          {
            label: "Project Qualification Step",
            path: "projectQualStep",
            type: "searchable",
            required: true,
            info: "Search and Select Project Qualification Step",
            searchType: "projectQualStep",
          },
        ]
      : []),
    {
      label: "Project Page Description",
      path: "projectPageDescription",
      type: "textarea",
    },
    {
      cols: 2,
      fields: [
        {
          label: "Project",
          path: "project",
          type: "searchable",
          required: true,
          info: "Search and select project",
          searchType: "project",
        },
        {
          label: "Project Objective",
          path: "projectObjective",
          type: "searchable",
          info: "Search and select project objective",
          searchType: "projectObjective",
        },
      ],
    },
  ];
}
